import { eachDayOfInterval, parseISO } from "date-fns";

export const EachDayOfInterval = (reservas: any, bloqued: any) => {
  let dateArray: any = [];

  reservas.map((reserva: any) => {
    if (reserva.status == "pending" || reserva.status == "approved") {
      const startDate = parseISO(reserva.start_date);
      const endDate = parseISO(reserva.end_date);
      const days = eachDayOfInterval({ start: startDate, end: endDate });

      dateArray = dateArray.concat(days);
    }
  });

  if (bloqued && bloqued.length > 0) {
    const fechaMasLejana = new Date(
      Math.max(...dateArray, ...bloqued.map((f: any) => new Date(f).getTime()))
    );
    dateArray.push(fechaMasLejana);
  }
  return dateArray;
};
